var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container containerBox"},[_c('cmp-charge',{attrs:{"form":_vm.schemeInfo},on:{"onSave":_vm.onSaveCharge}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }